module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-shizuoka-3-454298277acb485e29bd6ef402c2e2dd.jpg";